import { atom } from 'jotai';
import { episodeActs } from '@/constants';
import type { ActsType } from '@/enums';

export const actsAtom = atom<ActsType[]>(episodeActs);
